import axios from "axios";
import React, { useEffect } from "react";

function GetHost() {
  let host = "https://api.smartg.kr:3000";
  if (process.env.REACT_APP_ENV === "dev") host = "http://192.168.0.50:3000";
  if (process.env.REACT_APP_ENV === "staging") host = "http://192.168.76.23:3000";
  return host;
}

export default GetHost;
